import type { SVGComponentProps } from 'BreetHelpers';

export const AssetInfoIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='33'
		height='33'
		viewBox='0 0 33 33'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<g clipPath='url(#clip0_12129_224807)'>
			<path
				d='M18.2939 11.6331C18.3739 11.6102 18.4454 11.5759 18.5054 11.5273L18.2939 11.6331Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M24.2655 23.7839C24.2655 25.6725 23.9427 27.2153 23.2998 28.4153C22.7912 29.3581 22.0826 30.0896 21.1769 30.6067C21.074 30.6667 20.9683 30.721 20.8598 30.7753L20.8226 30.7924C19.2397 31.5524 17.4083 31.501 15.3283 30.6439H15.3255C14.7912 30.4239 14.2426 30.1496 13.6769 29.821V31.1724C13.6769 31.3667 13.6198 31.4924 13.5083 31.5524L13.4969 31.5581C13.4569 31.5781 13.4083 31.5896 13.3541 31.5924C13.1369 31.6039 12.9312 31.461 12.7341 31.1696L9.05692 25.8725C8.74549 25.421 8.58838 24.9696 8.58838 24.521C8.58838 24.1839 8.67692 23.9496 8.84835 23.8153L9.03689 23.7182L9.05406 23.7125L12.7312 22.661C12.9284 22.5953 13.1341 22.6925 13.3512 22.9525C13.5655 23.2096 13.674 23.4753 13.674 23.7467V25.0953C14.8398 25.7668 15.8912 26.0668 16.834 25.9925C17.3369 25.9525 17.8083 25.8096 18.2483 25.5582C19.2512 24.9868 19.8569 23.9982 20.0626 22.5925C20.1198 22.2267 20.1455 21.8296 20.1455 21.4067C20.1455 20.6639 20.0512 19.8953 19.8655 19.1011C19.6798 18.3068 19.4198 17.5211 19.0855 16.7439C18.8712 16.2582 18.7826 15.821 18.8226 15.4267C18.8483 15.1553 18.9341 14.9611 19.0827 14.8439C19.1112 14.8182 19.1455 14.7953 19.1797 14.7753L19.2083 14.761C19.2426 14.7439 19.2826 14.7296 19.3226 14.7182L19.3455 14.7125L20.3226 14.4525C20.674 14.3411 21.0683 14.4496 21.4998 14.7782C21.9312 15.1068 22.274 15.5468 22.5283 16.0982C23.0769 17.3839 23.5026 18.6753 23.8083 19.9753C24.0111 20.8467 24.1455 21.7039 24.2112 22.5439C24.2455 22.961 24.2626 23.3753 24.2626 23.7839H24.2655Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M18.7659 10.826C18.7659 11.1603 18.6802 11.3946 18.5059 11.5289L18.2945 11.6346L14.6173 12.686C14.4231 12.7517 14.2174 12.6546 14.0002 12.3946C13.7859 12.1374 13.6773 11.8717 13.6773 11.6003V10.2517C13.4487 10.1203 13.2231 10.0003 13.0031 9.8974C11.5031 9.19454 10.2059 9.16026 9.10302 9.78883C9.01731 9.8374 8.93162 9.89171 8.85162 9.946C7.75448 10.7003 7.20591 12.0345 7.20591 13.9403C7.20591 14.6831 7.29734 15.4517 7.48591 16.246C7.67162 17.0403 7.93162 17.826 8.26305 18.6031C8.4802 19.0889 8.56874 19.526 8.52874 19.9203C8.49731 20.2403 8.38017 20.4546 8.18017 20.566C8.13445 20.5946 8.08302 20.6146 8.02874 20.6289L7.02874 20.8946C6.67445 21.006 6.28305 20.9031 5.85162 20.586C5.42019 20.2689 5.07732 19.8231 4.82303 19.2489C4.25446 17.9517 3.82303 16.6574 3.52874 15.3631C3.23445 14.066 3.08594 12.8003 3.08594 11.5631C3.08594 8.18886 4.11731 5.91171 6.17445 4.74028C6.33159 4.64886 6.49451 4.56886 6.65737 4.50028C7.60594 4.06886 8.64305 3.92883 9.76591 4.07454C10.9688 4.23168 12.2716 4.71457 13.6773 5.526V4.17457C13.6773 3.906 13.7859 3.76597 14.0002 3.75454C14.2174 3.74311 14.4231 3.886 14.6173 4.17743L16.2288 6.49743L18.2945 9.47454C18.6088 9.92597 18.7659 10.3774 18.7659 10.826Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M19.4658 1.02027L19.7144 0.894531C19.603 0.900246 19.5172 0.943123 19.4658 1.02027Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M29.98 20.9323C29.98 24.3066 28.9514 26.5838 26.8914 27.7552L26.7286 27.838L26.4685 27.9695L26.4229 27.9895L20.86 30.7809C20.9686 30.7266 21.0743 30.6723 21.1771 30.6123C22.0828 30.0952 22.7915 29.3637 23.3 28.4209C23.9429 27.2209 24.2657 25.678 24.2657 23.7895C24.2657 23.3809 24.2486 22.9666 24.2143 22.5495C24.1486 21.7095 24.0143 20.8523 23.8114 19.9809C23.5057 18.6809 23.08 17.3895 22.5314 16.1038C22.2771 15.5524 21.9343 15.1124 21.5029 14.7838C21.0715 14.4552 20.6771 14.3466 20.3257 14.4581L19.3486 14.718L19.3257 14.7238C19.2857 14.7352 19.2457 14.7495 19.2114 14.7666L24.8943 11.9238C24.9371 11.9009 24.9857 11.8809 25.04 11.8666L26.04 11.6009C26.3914 11.4895 26.7857 11.5981 27.2172 11.9266C27.6486 12.2552 27.9914 12.6952 28.2457 13.2466C28.7943 14.5324 29.22 15.8238 29.5257 17.1238C29.8285 18.4266 29.98 19.6952 29.98 20.9323Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M20.0654 22.5926C19.8596 23.9983 19.2539 24.9869 18.2511 25.5583C17.8111 25.8097 17.3396 25.9526 16.8368 25.9926C15.8939 26.0669 14.8425 25.7669 13.6768 25.0954L15.5596 24.1525L19.391 22.2383C19.6196 22.3697 19.8454 22.4897 20.0654 22.5926Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M19.3909 20.8907V22.2393L15.5595 24.1536L13.6766 25.0965V23.7479C13.6766 23.4764 13.5681 23.2108 13.3538 22.9536C13.1367 22.6936 12.931 22.5965 12.7338 22.6622L9.05664 23.7136L14.6481 20.905L14.6652 20.8965C14.6995 20.8793 14.7338 20.8679 14.7709 20.8564L18.4481 19.805C18.6452 19.7393 18.851 19.8365 19.0681 20.0965C19.2824 20.3536 19.3909 20.6193 19.3909 20.8907Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.2427 17.0606C14.2113 17.3835 14.0941 17.5977 13.8913 17.7092L13.8399 17.7349L8.17982 20.5635C8.37982 20.452 8.49697 20.2377 8.5284 19.9177C8.5684 19.5235 8.47985 19.0863 8.26271 18.6006C7.93128 17.8235 7.67128 17.0377 7.48557 16.2435C7.29699 15.4492 7.20557 14.6806 7.20557 13.9377C7.20557 12.032 7.75414 10.6977 8.85128 9.94342C8.93128 9.88914 9.01697 9.83485 9.10268 9.78628C10.2055 9.15771 11.5027 9.19199 13.0027 9.89485C12.9456 10.2606 12.9199 10.6577 12.9199 11.0806C12.9199 11.8234 13.0113 12.592 13.1999 13.3863C13.3856 14.1806 13.6456 14.9663 13.977 15.7435C14.1941 16.2292 14.2827 16.6663 14.2427 17.0606Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M24.48 7.96659C24.48 8.41802 24.3229 8.68662 24.0086 8.77519L18.5057 11.5266C18.68 11.3923 18.7657 11.158 18.7657 10.8237C18.7657 10.3752 18.6086 9.92373 18.2943 9.4723L16.2286 6.49519L14.6171 4.17519C14.4228 3.88376 14.2171 3.74087 14 3.7523L17.78 1.86088L19.4657 1.0209L19.7143 0.895166C19.9314 0.883738 20.1371 1.02662 20.3314 1.31805L24.0086 6.61516C24.3229 7.06659 24.48 7.51802 24.48 7.96659Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M17.7801 1.86054L14.0001 3.75197C13.7858 3.7634 13.6772 3.90343 13.6772 4.172V5.5234C12.2715 4.71197 10.9686 4.22911 9.76577 4.07197C8.64291 3.92626 7.6058 4.06629 6.65723 4.49771L11.8886 1.88055C13.5629 0.926269 15.5258 0.920538 17.7801 1.86054Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.3254 30.6471L13.5083 31.5556C13.6197 31.4956 13.6768 31.3699 13.6768 31.1756V29.8242C14.2425 30.1528 14.7911 30.4271 15.3254 30.6471Z'
				fill='#022745'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.0572 23.7148L9.04003 23.7206L8.85149 23.8149L8.84863 23.8177'
				fill='#022745'
			/>
			<path
				d='M9.0572 23.7148L9.04003 23.7206L8.85149 23.8149L8.84863 23.8177'
				stroke='white'
				strokeWidth='0.8'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</g>
		<defs>
			<clipPath id='clip0_12129_224807'>
				<rect
					width='32'
					height='32'
					fill='white'
					transform='translate(0.5 0.253906)'
				/>
			</clipPath>
		</defs>
	</svg>
);
